import { ReactNode } from "react"

import moment from "moment"

import PersonEdit, { PersonProps, PersonState } from "../EntityEdit"
import PersonForm from "./PersonForm"

import Modal from "../../../libs/ui/modal/Modal"
import ModalWaith from "../../../libs/ui/modal/ModalWaith"

import { DATE_FORMAT } from "../../../libs/validation/dateValidation"


class PersonUpdate extends PersonEdit<PersonProps, PersonState> {

    constructor (props: any) {
        super(props)

        this.state = this.getInitialState(props)

        this.getInitialState = this.getInitialState.bind(this)
    }

    render(): ReactNode {
        const person = this.props.person

        const title = person?.name + ' ' + person?.surname

        const dataNascita = moment( person?.dateOfBirth ?? new Date()).format(DATE_FORMAT)

        return (
            <>
                <span 
                    id={'editButton_' + person?.id}
                    className='editButton'
                    onClick={this.toggle}
                >
                    Modifica i dati
                </span>

                <Modal 
                    title={title}
                    buttonText='Salva Modifiche'
                    isOpen={this.state.isOpen && !this.state.waith}
                    callBackToggle={this.toggle}
                    callBackSendData={this.sendData}
                    error={this.state.globalError}
                >
                    <p>
                        <strong className="titleLev6">Informazioni principali</strong><br/>
                        {
                            person?.gender 
                            ? person?.gender + ', '
                            : ''
                        } 
                        data di nascita {dataNascita} 
                    </p>

                    <PersonForm 
                        nome={person?.name}
                        cognome={person?.surname}
                        email={this.state.email}
                        cellulare={this.state.cellulare}
                        sesso={this.state.sesso}
                        dataNascita={this.state.dataNascita}
                        natoInItalia={this.state.natoInItalia}
                        stato_nascita={this.state.stato_nascita}
                        comune_nascita={this.state.comune_nascita}
                        professione={this.state.professione}
                        indirizzoResidenza={this.state.indirizzoResidenza}

                        street={this.state.street}
                        street_number={this.state.street_number}
                        zip={this.state.zip}
                        city={this.state.city}

                        profList={this.props.profList}
                        statiList={this.props.statiList}

                        updateName={this.voidFunction}
                        updateCognome={this.voidFunction}
                        updateEmail={this.updateEmail}
                        updateCellulare={this.updateCellulare}
                        updateSesso={this.updateSesso}
                        updateDataNascita={this.updateDataNascita}
                        updateNatoInItalia={this.updateNatoInItalia}
                        updateStatoNascita={this.updateStato_nascita}
                        updateComuneNascita={this.updateComune_nascita}
                        updateProfessione={this.updateProfessione}
                        updateIndirizzo={this.updateIndirizzoResidenza}
                        updateStreet={this.updateStreet}
                        updateStreet_number={this.updateStreet_number}
                        updateZip={this.updateZip}
                        updateCity={this.updateCity}
                        updateAllAddressParts={this.updateAllAddressParts}

                        is_manual_address={this.state.is_manual_address}
                        updateManualSelectionCallBack={this.updateIsManualAddress}
                        
                        nomeError={undefined}
                        cognomeError={undefined}
                        emailError={this.state.emailError}
                        phoneError={this.state.phoneError}
                        sessoError={this.state.sessoError}
                        dataNascitaError={this.state.dataNascitaError}
                        natoInItaliaError={this.state.natoInItaliaError}
                        comuneError={this.state.comune_nascitaError}
                        statoError={this.state.stato_nascitaError}
                        indirizzoResidenzaError={this.state.indirizzoResidenzaError}
                        profeError={this.state.profeError}

                        clearNomeError={this.voidFunction}
                        clearCognomeError={this.voidFunction}
                        clearEmailError={this.clearEmailError}
                        clearPhoneError={this.clearCellulareError}
                        clearProfeError={this.clearProfessioneError}
                        clearSessoError={this.clearSessoError}
                        clearDataNascitaError={this.clearDataNascitaError}
                        clearNatoInItaliaError={this.clearNatoInItaliaError}
                        clearComuneError={this.clearComune_nascitaError}
                        clearStatoError={this.clearStato_nascitaError}
                        clearIndirizzoResidenzaError={this.clearIndirizzoResidenzaError}

                        expiredSessionCallbak={this.props.expiredSessionCallbak}

                        hideProfessione={this.props.hideProfessione}
                    />
                </Modal>

                <ModalWaith isOpen={this.state.waith}/>
            </>
        )
    }
    
    getInitialState (props?: any) {
        const persona = props?.person

        // decido da dove leggere
        return (props)
            ?   {
                    id: persona.id ?? '',
                    nome: persona.name,
                    cognome: persona.surname,
                    email: persona.email,
                    cellulare: persona.phone,
                    professione: persona.profession,
                    sesso: persona.gender,
                    dataNascita: (persona.dateOfBirth) ? moment(persona.dateOfBirth).format(DATE_FORMAT) : persona.dateOfBirth, 
                    natoInItalia: persona.bornInItaly,
                    stato_nascita: persona.countryOfBirth?.id,
                    comune_nascita: persona.cityOfBirth?.id,
                    indirizzoResidenza: (persona.indirizzoResidenza !== undefined) ? persona.indirizzoResidenza.toUpperCase() : persona.indirizzoResidenza,
                    street: persona.address,
                    street_number: (persona.addressNumber !== undefined) ? persona.addressNumber.toUpperCase() : persona.addressNumber,
                    zip: persona.postalCodeOfResidence,
                    city: (persona.cityOfResidence?.id !== undefined) ? persona.cityOfResidence.id.toUpperCase() : persona.cityOfResidence?.id,

                    is_manual_address: (persona.is_manual_address !== undefined) ? persona.is_manual_address !== undefined : false,

                    emailError: undefined,
                    cellulareError: undefined,
                    profeError: undefined,
                    globalError: undefined,
                    sessoError: undefined,
                    dataNascitaError: undefined,
                    natoInItaliaError: undefined,
                    stato_nascitaError: undefined,
                    comune_nascitaError: undefined,
                    indirizzoResidenzaError: undefined,
                    streetError: undefined,
                    street_numberError: undefined,
                    zipError: undefined,
                    cityError: undefined,
                    isOpen: false,
                    waith: false
                }
            :   {
                    id: this.state?.id ?? '',
                    nome: this.state?.nome,
                    cognome: this.state?.cognome,
                    email: this.state?.email,
                    cellulare: this.state?.cellulare,
                    professione: this.state?.professione,
                    sesso: this.state?.sesso,
                    dataNascita: this.state?.dataNascita,
                    natoInItalia: this.state?.natoInItalia,
                    stato_nascita: this.state?.stato_nascita,
                    comune_nascita: this.state?.comune_nascita,
                    indirizzoResidenza: this.state?.indirizzoResidenza,
                    street: this.state?.street,
                    street_number: this.state?.street_number,
                    zip: this.state?.zip,
                    city: this.state?.city,
                    is_manual_address: (this.state.is_manual_address !== undefined) ? this.state.is_manual_address !== undefined : false,

                    emailError: undefined,
                    cellulareError: undefined,
                    profeError: undefined,
                    globalError: undefined,
                    sessoError: undefined,
                    dataNascitaError: undefined,
                    natoInItaliaError: undefined,
                    stato_nascitaError: undefined,
                    comune_nascitaError: undefined,
                    indirizzoResidenzaError: undefined,
                    streetError: undefined,
                    street_numberError: undefined,
                    zipError: undefined,
                    cityError: undefined,
                    isOpen: false,
                    waith: false
                }
    }

}

export default PersonUpdate